module.exports = {"AE":{"code":"AE","name":"United Arab Emirates","countryCode":"+971","cities":["Dubai","Abu Dhabi","Sharjah"]}}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/data/countries_en.json
// module id = 1703
// module chunks = 2